export default function SvgValidate5() {
    return (
      <>
       <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15px"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="blue"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20 7L9 18l-5-5"
        ></path>
      </svg>
    </>
  );
}
